import React from 'react';
import { Bell, Search, Settings } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
export function Header() {
  const {
    user
  } = useAuth();
  return <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-6 sticky top-0 z-30" data-id="element-28">
      {/* Left: Breadcrumbs or Page Title (Placeholder) */}
      <div className="flex items-center" data-id="element-29">
        <h2 className="text-lg font-semibold text-slate-800" data-id="element-30">
          Dashboard Overview
        </h2>
      </div>

      {/* Right: Actions */}
      <div className="flex items-center space-x-4" data-id="element-31">
        <div className="relative hidden md:block" data-id="element-32">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" data-id="element-33" />
          <input type="text" placeholder="Search..." className="h-9 pl-9 pr-4 rounded-full bg-slate-100 border-none text-sm focus:ring-2 focus:ring-emerald-500 w-64" data-id="element-34" />
        </div>

        <button className="relative p-2 rounded-full hover:bg-slate-100 text-slate-600 transition-colors" data-id="element-35">
          <Bell size={20} data-id="element-36" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full border-2 border-white" data-id="element-37"></span>
        </button>

        <button className="p-2 rounded-full hover:bg-slate-100 text-slate-600 transition-colors" data-id="element-38">
          <Settings size={20} data-id="element-39" />
        </button>

        <div className="h-8 w-px bg-slate-200 mx-2" data-id="element-40"></div>

        <div className="flex items-center space-x-2" data-id="element-41">
          <span className="text-sm font-medium text-slate-700 hidden sm:block" data-id="element-42">
            {user?.name}
          </span>
        </div>
      </div>
    </header>;
}